<template>
	<div>
		<PageHeaderLayout>
			<div class="main-page-content">
				<el-row class="table-search">
					<el-form :inline="true" :model="searchCondition" class="demo-form-inline">
						<el-form-item v-for="item in searchList" :key="item.props" :label="item.label">
							<el-input
								v-if="item.type === 'input'"
								v-model="searchCondition[item.props]"
								:placeholder="'请输入' + item.label"
								clearable
							></el-input>
							<el-select
								v-if="item.type === 'select'"
								v-model="searchCondition[item.props]"
								:placeholder="'请选择' + item.label"
								clearable
								@change="handleSearchSelectChange(item)"
							>
								<el-option v-for="option in item.selectData" :key="option.value" :label="option.label" :value="option.value"></el-option>
							</el-select>
							<DatePicker v-if="item.type === 'date'" @dataSearch="dataSearch(item.props, $event)" />
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="searchButton">查询</el-button>
							<el-button type="primary" @click="createNews">创建资讯</el-button>
						</el-form-item>
					</el-form>
				</el-row>

				<ApeTable
					ref="apeTable"
					:data="tableData"
					:columns="columns"
					:loading="loadingStaus"
					:pagingData="pagingData"
					@switchPaging="switchPaging"
					highlight-current-row
				>
					<el-table-column label="资讯内容" width="350" align="center">
						<template slot-scope="scope">
							<el-tooltip
								v-if="scope.row.profile"
								effect="dark"
								:content="scope.row.profile"
								placement="top"
								popper-class="information-profile-tooltip"
							>
								<div class="information-profile-ellipsis">{{ scope.row.profile }}</div>
							</el-tooltip>
							<span v-else>-</span>
						</template>
					</el-table-column>
					<el-table-column label="首页推荐" width="140" align="center">
						<template slot-scope="scope">
							<el-switch
								:value="scope.row.is_recommend == 1"
								@change="openSwitchConfirm(scope.row, 'is_recommend')"
							></el-switch>
						</template>
					</el-table-column>
					<el-table-column label="是否置顶" width="140" align="center">
						<template slot-scope="scope">
							<el-switch
								:value="scope.row.is_top == 1"
								@change="openSwitchConfirm(scope.row, 'is_top')"
							></el-switch>
						</template>
					</el-table-column>
					<el-table-column label="公告状态" width="100" align="center">
						<template slot-scope="scope">
							<el-switch
								:value="scope.row.is_display == 1"
								@change="changeDisplay(scope.row)"
							></el-switch>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="220" align="center" fixed="right">
						<template slot-scope="scope">
							<el-button type="text" size="mini" @click="editNews(scope.row)">编辑</el-button>
							<el-button type="text" size="mini" @click="showDetail(scope.row)">详情</el-button>
							<!-- <el-button type="text" size="mini" @click="openResync(scope.row)">同步</el-button> -->
							<el-popover placement="top" width="150" v-model="scope.row.deleteVisible">
								<p>确定要删除该资讯吗？</p>
								<div style="text-align: right; margin: 0;">
									<el-button type="text" size="mini" @click="scope.row.deleteVisible = false">取消</el-button>
									<el-button type="danger" size="mini" @click="deleteNews(scope.row)">确定</el-button>
								</div>
								<el-button slot="reference" type="text" size="mini" style="color: #f56c6c;">删除</el-button>
							</el-popover>
						</template>
					</el-table-column>
				</ApeTable>
			</div>
		</PageHeaderLayout>

		<el-dialog title="资讯" :visible.sync="newsVisible" width="90%" @close="closeNewsDialog">
			<el-form ref="newsForm" :model="newsForm" :rules="newsRules" label-width="110px" class="news-form">
				<el-form-item label="资讯标题" prop="title">
					<el-input v-model="newsForm.title" placeholder="请输入资讯标题"></el-input>
				</el-form-item>
				<el-form-item label="是否置顶" prop="is_top">
					<el-select v-model="newsForm.is_top" placeholder="请选择是否置顶">
						<el-option v-for="item in topItemList" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="首页推荐" prop="is_recommend">
					<el-select v-model="newsForm.is_recommend" placeholder="请选择首页推荐">
						<el-option v-for="item in recommendItemList" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-show="false" label="发布位置" prop="publish_type">
					<el-select
						v-model="newsForm.publish_type"
						placeholder="请选择发布位置"
						:multiple="dialogFlag === 'add'"
						:disabled="dialogFlag !== 'add'"
						clearable
					>
						<el-option v-for="item in publishTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="showMiniPublishType" label="小程序位置" prop="mini_publish_type">
					<el-select v-model="newsForm.mini_publish_type" placeholder="请选择小程序位置" clearable>
						<el-option v-for="item in miniPublishTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="showCoverUpload" label="资讯封面图" prop="cover_url_arr">
					<UploadImg
						ref="coverUpload"
						:accept="['png', 'jpg', 'jpeg', 'webp']"
						:upload-props="{ limit: 1, maxSize: 2 }"
						@successFile="handleCoverSuccess"
						@removeFile="handleCoverSuccess"
					/>
					<div class="image-after-tip">上传图片建议 690*400，仅支持 JPG/JPEG/PNG/WEBP 格式</div>
				</el-form-item>
				<el-form-item label="资讯内容" prop="content">
					<ApeEditor
						:init-html="newsForm.content"
						:editor-height="520"
						:oss-data="ossData"
						:oss-obj="ossObj"
						@handleTinymceInput="handleEditorInput"
					/>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="closeNewsDialog">取 消</el-button>
				<el-button type="primary" :loading="submitLoading" @click="submitNews">确 定</el-button>
			</span>
		</el-dialog>

		<el-dialog title="详情" :visible.sync="detailVisible" width="80%" @close="detailHtml = ''">
			<div class="detail-html" v-html="detailHtml"></div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="detailVisible = false">关 闭</el-button>
			</span>
		</el-dialog>

		<el-dialog :title="switchDialog.title" :visible.sync="switchDialog.visible" width="300px" @close="switchTarget = {}">
			<div>{{ switchDialog.content }}</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="switchDialog.visible = false">取 消</el-button>
				<el-button type="primary" @click="confirmSwitch">确 定</el-button>
			</span>
		</el-dialog>

		<!-- <el-dialog title="同步到其他平台" :visible.sync="resyncVisible" width="420px" @close="resyncVisible = false">
			<el-form :model="resyncForm" label-width="90px">
				<el-form-item label="资讯标题">
					<el-input v-model="resyncForm.title" disabled></el-input>
				</el-form-item>
				<el-form-item label="同步至">
					<el-select v-model="resyncForm.pos" multiple placeholder="请选择发布位置" clearable>
						<el-option
							v-for="item in publishTypeList"
							:key="item.value"
							:label="item.label"
							:value="item.value"
							:disabled="resyncDisable.publish_list && resyncDisable.publish_list.includes(item.value)"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="resyncForm.pos.includes(8)" label="小程序位置">
					<el-select v-model="resyncForm.miniappPos" placeholder="请选择小程序位置" clearable>
						<el-option
							v-for="item in miniPublishTypeList"
							:key="item.value"
							:label="item.label"
							:value="item.value"
							:disabled="resyncDisable.mini_publish_list && resyncDisable.mini_publish_list.includes(item.value)"
						></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="resyncVisible = false">取 消</el-button>
				<el-button type="primary" @click="confirmResync">确 定</el-button>
			</span>
		</el-dialog> -->
	</div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import DatePicker from '@/components/DatePicker.vue'
import UploadImg from '@/components/uploadImg/index.vue'
import ApeEditor from '@/components/ApeEditor/ApeEditor.vue'
import { search_list, tableColumns } from './config/information.ts'

export default {
	name: 'HrManagerInformation',
	components: {
		PageHeaderLayout,
		ApeTable,
		DatePicker,
		UploadImg,
		ApeEditor
	},
	data() {
		return {
			searchType: 1,
			searchCondition: {},
			loadingStaus: true,
			submitLoading: false,
			tableData: [],
			pagingData: {
				is_show: true,
				layout: 'total, sizes, prev, pager, next, jumper',
				total: 0
			},
			columns: tableColumns.filter(item => !['profile', 'is_recommend_text', 'is_top_text', 'is_display_text'].includes(item.value)),
			newsVisible: false,
			detailVisible: false,
			resyncVisible: false,
			detailHtml: '',
			dialogFlag: 'add',
			actionId: '',
			switchTarget: {},
			switchDialog: {
				visible: false,
				title: '',
				content: ''
			},
			resyncDisable: {},
			resyncForm: {
				title: '',
				pos: [],
				miniappPos: ''
			},
			newsForm: this.getDefaultNewsForm(),
			newsRules: {
				title: [{ required: true, message: '请输入资讯标题', trigger: 'blur' }],
				is_top: [{ required: true, message: '请选择是否置顶', trigger: 'change' }],
				is_recommend: [{ required: true, message: '请选择首页推荐', trigger: 'change' }],
				publish_type: [{ required: true, message: '请选择发布位置', trigger: 'change' }],
				content: [{ required: true, message: '请输入资讯内容', trigger: 'blur' }]
			},
			ossData: {},
			ossObj: {},
			topItemList: [
				{ value: 0, label: '否' },
				{ value: 1, label: '是' }
			],
			recommendItemList: [
				{ value: 2, label: '否' },
				{ value: 1, label: '是' }
			],
			miniPublishTypeList: [],
			publishTypeList: [
				{ value: 1, label: '区域数字化平台首页' },
				{ value: 2, label: '校企首页' },
				{ value: 3, label: '法律援助(法律法规)' },
				{ value: 4, label: '法律援助(本地政策)' },
				{ value: 7, label: '数字化产业基地' },
				{ value: 8, label: '大学小程序' }
			]
		}
	},
	computed: {
		searchList() {
			return search_list(this.searchType, this.miniPublishTypeList, this.publishTypeList)
		},
		showMiniPublishType() {
			const value = this.newsForm.publish_type
			return Array.isArray(value) ? value.includes(8) : value == 8
		},
		showCoverUpload() {
			const value = this.newsForm.publish_type
			if (Array.isArray(value)) {
				return value.some(item => [1, 2, 7, 8].includes(Number(item)))
			}
			return [1, 2, 7, 8].includes(Number(value))
		}
	},
	methods: {
		getDefaultNewsForm() {
			return {
				title: '',
				is_top: 0,
				is_recommend: 2,
				publish_type: [1],
				cover_url_arr: [],
				mini_publish_type: null,
				content: ''
			}
		},
		dataSearch(prop, value) {
			this.searchCondition[prop] = value
		},
		handleSearchSelectChange(item) {
			if (item.props === 'publish_type') {
				if (this.searchCondition.publish_type == 8) {
					this.searchType = 2
				} else {
					this.searchType = 1
					delete this.searchCondition.mini_publish_type
				}
			}
		},
		searchButton() {
			this.initList('search')
		},
		switchPaging() {
			this.initList()
		},
		getSearchParams() {
			const params = { ...this.searchCondition }
			if (params.date && params.date.length) {
				params.start_time = params.date[0]
				params.end_time = params.date[1]
				delete params.date
			}
			if (params.publish_type != 8) {
				delete params.mini_publish_type
			}
			return params
		},
		formatList(list) {
			return list.map(item => {
				return {
					...item,
					profile: item.profile || '',
					is_top_text: item.is_top == 1 ? '是' : '否',
					is_recommend_text: item.is_recommend == 1 ? '是' : '否',
					is_display_text: item.is_display == 1 ? '显示' : '隐藏',
					deleteVisible: false
				}
			})
		},
		async initList(type) {
			this.loadingStaus = true
			const pagingInfo = this.$refs['apeTable'].getPagingInfo(type)
			if (type === 'search') {
				pagingInfo.current_page = 1
			}
			try {
				const params = {
					...pagingInfo,
					...this.getSearchParams(),
					include_top: 1
				}
				const res = await this.$api.getInformationList(params)
				const list = res.data || res.list || []
				const pages = res.pages || { total: res.total || 0, offset: res.offset || 0 }
				this.tableData = this.formatList(list)
				this.pagingData.total = pages.total || 0
				this.pagingData.offset = pages.offset || 0
			} catch (e) {
				this.tableData = []
				this.$message.error(e.message || '获取资讯列表失败')
			}
			this.loadingStaus = false
		},
		createNews() {
			this.dialogFlag = 'add'
			this.actionId = ''
			this.newsForm = this.getDefaultNewsForm()
			this.newsVisible = true
			this.$nextTick(() => {
				if (this.$refs.coverUpload) {
					this.$refs.coverUpload.setImagesList([])
				}
			})
		},
		async editNews(row) {
			this.dialogFlag = 'edit'
			this.actionId = row.id
			try {
				const info = await this.$api.getInformationInfo(row.id)
				this.newsForm = {
					title: info.title || '',
					is_top: info.is_top != null ? info.is_top : 0,
					is_recommend: info.is_recommend != null ? info.is_recommend : 2,
					publish_type: info.publish_type,
					cover_url_arr: info.cover_url ? [info.cover_url] : [],
					mini_publish_type: info.mini_publish_type || null,
					content: info.content || ''
				}
				this.newsVisible = true
				this.$nextTick(() => {
					if (this.$refs.coverUpload) {
						this.$refs.coverUpload.setImagesList(this.newsForm.cover_url_arr)
					}
				})
			} catch (e) {
				this.$message.error(e.message || '获取资讯详情失败')
			}
		},
		closeNewsDialog() {
			this.newsVisible = false
			this.submitLoading = false
			this.$refs.newsForm && this.$refs.newsForm.clearValidate()
		},
		handleEditorInput(value) {
			this.newsForm.content = value
		},
		handleCoverSuccess() {
			this.newsForm.cover_url_arr = this.$refs.coverUpload ? this.$refs.coverUpload.getImagesList() : []
		},
		submitNews() {
			this.$refs.newsForm.validate(async valid => {
				if (!valid) return
				this.handleCoverSuccess()
				if (this.showCoverUpload && !this.newsForm.cover_url_arr.length) {
					this.$message.warning('请上传资讯封面图')
					return
				}
				this.submitLoading = true
				try {
					const params = {
						...this.newsForm,
						cover_url: this.newsForm.cover_url_arr[0] || ''
					}
					delete params.cover_url_arr
					if (this.dialogFlag === 'add') {
						await this.$api.createInformation(params)
					} else {
						await this.$api.editInformation(this.actionId, params)
					}
					this.$message.success('保存成功')
					this.closeNewsDialog()
					this.initList()
				} catch (e) {
					this.$message.error(e.message || '保存失败')
				}
				this.submitLoading = false
			})
		},
		async showDetail(row) {
			try {
				const res = await this.$api.getInformationInfo(row.id)
				this.detailHtml = res.content || ''
				this.detailVisible = true
			} catch (e) {
				this.$message.error(e.message || '获取详情失败')
			}
		},
		async deleteNews(row) {
			try {
				await this.$api.deleteInformation(row.id)
				this.$message.success('删除成功')
				row.deleteVisible = false
				this.initList('del')
			} catch (e) {
				this.$message.error(e.message || '删除失败')
			}
		},
		openSwitchConfirm(row, type) {
			this.switchTarget = { row, type }
			if (type === 'is_top') {
				this.switchDialog = {
					visible: true,
					title: row.is_top == 0 ? '是否置顶' : '取消置顶',
					content: row.is_top == 0 ? '列表内置顶此资讯？' : '取消置顶此资讯？'
				}
			}
			if (type === 'is_recommend') {
				this.switchDialog = {
					visible: true,
					title: row.is_recommend == 2 ? '首页推荐' : '取消推荐',
					content: row.is_recommend == 2 ? '推荐资讯至首页？' : '取消推荐资讯？'
				}
			}
		},
		async confirmSwitch() {
			const { row, type } = this.switchTarget
			if (!row || !type) return
			const params = {}
			if (type === 'is_top') {
				params.is_top = row.is_top == 0 ? 1 : 0
			}
			if (type === 'is_recommend') {
				params.is_recommend = row.is_recommend == 2 ? 1 : 2
			}
			try {
				await this.$api.editInformation(row.id, params)
				this.$message.success('操作成功')
			} catch (e) {
				this.$message.error(e.message || '操作失败')
			}
			this.switchDialog.visible = false
			this.initList()
		},
		async changeDisplay(row) {
			try {
				await this.$api.editInformation(row.id, {
					is_display: row.is_display == 1 ? 2 : 1
				})
				this.$message.success('操作成功')
				this.initList()
			} catch (e) {
				this.$message.error(e.message || '操作失败')
				this.initList()
			}
		},
		async openResync(row) {
			this.actionId = row.id
			this.resyncForm = {
				title: row.title,
				pos: [],
				miniappPos: ''
			}
			this.resyncVisible = true
			try {
				this.resyncDisable = await this.$api.getInformationPublishList({ id: row.id })
			} catch (e) {
				this.resyncDisable = {}
			}
		},
		async confirmResync() {
			if (!this.resyncForm.pos.length) {
				this.$message.warning('请选择同步位置')
				return
			}
			if (this.resyncForm.pos.includes(8) && !this.resyncForm.miniappPos) {
				this.$message.warning('请选择小程序位置')
				return
			}
			try {
				await this.$api.publishSyncSet({
					id: this.actionId,
					publish_type: this.resyncForm.pos,
					mini_publish_type: this.resyncForm.miniappPos
				})
				this.$message.success('同步成功')
				this.resyncVisible = false
			} catch (e) {
				this.$message.error(e.message || '同步失败')
			}
		},
		async getPublishTypeList() {
			try {
				const res = await this.$api.getPublishTypeList()
				this.publishTypeList = (res || []).map(item => ({
					value: item.publish_type,
					label: item.publish_name
				}))
			} catch (e) {
				// 保留默认发布位置
			}
		},
		async getMiniappPublishPos() {
			try {
				const res = await this.$api.getMiniappPublishPos()
				this.miniPublishTypeList = (res || []).map(item => ({
					value: item.publish_id,
					label: item.back_publish_name
				}))
			} catch (e) {
				this.miniPublishTypeList = []
			}
		},
		async getOssSign() {
			try {
				const ossDir = `${this.$config.ossAppDir || ''}/bill`
				const res = await this.$api.getOssSign({ dir: ossDir })
				if (res) {
					this.ossObj = { ...res, dir: res.dir || ossDir }
					this.ossData = {
						ossAccessKeyId: res.accessid,
						policy: res.policy,
						signature: res.signature
					}
				}
			} catch (e) {
				// 富文本图片上传失败时由编辑器处理
			}
		}
	},
	mounted() {
		this.getOssSign()
		this.getMiniappPublishPos()
		this.getPublishTypeList()
		this.initList()
	}
}
</script>

<style scoped lang="scss">
.table-search {
	margin-bottom: 16px;
}
.image-after-tip {
	font-size: 12px;
	color: #939393;
	line-height: 1.5;
	margin-top: 8px;
}
.detail-html {
	max-height: 62vh;
	overflow: auto;
	font-size: 14px;
	line-height: 28px;
	color: #4e5969;
	/deep/ img {
		max-width: 100%;
		height: auto;
	}
}
.news-form {
	max-height: calc(100vh - 260px);
	overflow: auto;
	padding-right: 16px;
}
.information-profile-ellipsis {
	display: -webkit-box;
	overflow: hidden;
	text-overflow: ellipsis;
	line-clamp: 2;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	line-height: 20px;
	text-align: left;
}
</style>

<style lang="scss">
.information-profile-tooltip {
	max-width: 420px;
	line-height: 20px;
	white-space: normal;
	word-break: break-all;
}
</style>
